import { Box, Button, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LinkButton } from '../../components';
import useSendCodeForgotPassword from '../../hooks/account/useCodePinResertPassword';
import { LoginForm } from '../../services/types';
import { loginRequest } from '../../store/ducks/auth/actions';
import { loginDistributorRequest } from '../../store/ducks/distributor/actions';
import './styles.scss';
import validationSchema, { formSchemaType } from './validations';
import FretappLogo from '../../assets/images/fretapp-logo';
import { useForm } from 'react-hook-form';
import PasswordInput from '../../components/atoms/password-input';
import Typography from '../../components/atoms/typography';
import { yupResolver } from '@hookform/resolvers/yup';
import ControllerInput from '../../components/atoms/controller-input';
import ButtonComponent from '../../components/atoms/button';
import Input from '../../components/atoms/input';
import ModalCustom from '../../components/atoms/modalCustom';

type EmailForm = {
  email: string;
};
const Login: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { sendCode, loading: loadingSendCode } = useSendCodeForgotPassword();

  const [emailValue, setEmailValue] = useState<EmailForm>({
    email: '',
  });

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<formSchemaType>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'onChange',
  });

  const onSubmit = async (form: LoginForm) => {
    try {
      setLoading(true);
      if (location.pathname === '/admin/login') {
        dispatch(loginRequest({ email: form.email, password: form.password }));
      } else {
        dispatch(
          loginDistributorRequest({
            email: form.email,
            password: form.password,
          }),
        );
      }
    } catch (error) {
      toast.error((error as any).message);
    } finally {
      setLoading(false);
    }
  };

  const formSignIn = (
    <Form>
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12}>
          <ControllerInput
            name="email"
            control={control}
            label={'Usuário'}
            placeholder="Insira aqui seu e-mail"
          />
        </Grid>
        <Grid item xs={12}>
          <PasswordInput
            name="password"
            control={control}
            label={'Senha'}
            placeholder="Insira aqui sua senha"
          />
        </Grid>
      </Grid>

      <ButtonComponent
        disabled={!isValid}
        loading={loading}
        onClick={handleSubmit(onSubmit)}
        justifyContent="stretch"
      >
        Entrar
      </ButtonComponent>
    </Form>
  );

  const onNavigationClick = (path: string) => {
    history.push(path);
  };
  const onSendCode = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const admin = {
      email: emailValue.email,
    };
    if (location.pathname === '/admin/login') {
      const { status } = await sendCode(admin);
      if (status === 201) {
        onNavigationClick(`/Reset/Password`);
      }
    }
  };

  return (
    <Container fluid className="container-login">
      <Row>
        <Col className="container-form" xl={6}>
          <FretappLogo className="logo-fretapp" />

          {formSignIn}
          <Box display={'flex'} marginTop={2}>
            <Typography fontWeight="700" color="gray">
              Esqueceu a senha?
            </Typography>
            <Box marginRight={0.5} />
            <LinkButton
              title="Recuperar senha."
              onClick={() => setShowModal(true)}
            />
          </Box>

          {location.pathname === '/admin/login' ? (
            <Modal
              centered
              show={showModal}
              onHide={() => setShowModal(false)}
              className="forgot-password-modal"
            >
              <Modal.Header closeButton>
                <h5>Recuperar Senha</h5>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={event => onSendCode(event)}>
                  <Form.Label>
                    Insira o e-mail associado a sua conta da Fretapp. Enviaremos
                    um token para redefinir sua senha.
                  </Form.Label>
                  <Input
                    name="email"
                    value={emailValue.email}
                    label={'E-mail'}
                    placeholder=" Informe seu email"
                    control={control}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setEmailValue({
                        ...emailValue,
                        email: event.target.value,
                      })
                    }
                  />
                  <br />
                  <Button
                    type="submit"
                    className="primary-button"
                    disabled={loadingSendCode}
                  >
                    {loadingSendCode ? 'Enviando...' : 'Enviar'}
                  </Button>
                </Form>
              </Modal.Body>
            </Modal>
          ) : (
            <>
              <ModalCustom
                open={showModal}
                label={'Recuperação de senha'}
                onCancelClick={() => setShowModal(false)}
                children={
                  '  Entre em contato com o administrador da distribuidora, para poder ajudá-lo a recuperar sua senha. Não esqueça de informar seu nome de usuário e e-mail'
                }
              />
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
